import React, { useState } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { reportSurvey } from 'reducers/dailyCheckup/checkupEdit';
// components
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button';
import Preloader from 'components/Preloader';
import Translation from 'components/Translation';
// utils
import { isSomeSectionReporting } from 'utils/checkupHelper';
import { toastResponseErrors } from 'utils/responseErrorsHelper';
import cn from 'classnames';
// styles
import './CheckupSegment/CheckupSegment.scss';
import './ReportSurveyInputSegment.scss';

const ReportSurveyInputSegment = ({
  checkup,
  paramsCheckupId,
  isDisabled,
  isSubmitting,
  reportSurvey,
  survey,
  validateCheckup,
}) => {
  const { value_text: valueText, id, question } = survey;
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [draft, setDraft] = useState(valueText || '');

  const isAnswered = valueText !== null && valueText !== undefined && valueText !== '';
  const showInput = isEdit || !isAnswered;
  const isCurrentSubmitting = isSubmitting && isLoading;
  const isOtherSubmitting = isSubmitting && !isLoading;
  const disabled = isDisabled || isOtherSubmitting;

  const handleSave = () => {
    if (!validateCheckup(checkup)) return;
    const trimmed = draft.trim();
    if (!trimmed) return;
    setIsLoading(true);
    reportSurvey(paramsCheckupId, { dc_surveys: [{ id, value_text: trimmed }] })
      .then(() => setIsEdit(false))
      .catch(toastResponseErrors)
      .finally(() => setIsLoading(false));
  };

  const handleEdit = () => {
    setDraft(valueText || '');
    setIsEdit(true);
  };

  return (
    <div className={cn('checkup-segment', 'survey-input-segment', { 'reported': isAnswered, 'is-disabled': disabled })}>
      <Preloader className="segment-preloader" isActive={isCurrentSubmitting} />
      <div className="checkup-segment-content">
        {isAnswered && !isEdit && (
          <div className="segment-icon-column">
            <i className="fa fa-check-circle-bts status-icon" />
          </div>
        )}
        <div className={cn('segment-info-column', { isReported: isAnswered && !isEdit })}>
          <div className="segment-title">
            <Translation text={question}>{question}</Translation>
            {isAnswered && !isEdit && <span className="value"> • {valueText}</span>}
          </div>
        </div>
        <div className="segment-buttons-column">
          {showInput ? (
            <div className="survey-input-controls">
              <FormattedMessage id="general.typeResponse">
                {(placeholder) => (
                  <input
                    type="text"
                    className="survey-input"
                    value={draft}
                    placeholder={placeholder}
                    disabled={disabled || isCurrentSubmitting}
                    onChange={(e) => setDraft(e.target.value)}
                  />
                )}
              </FormattedMessage>
              <Button
                light
                className="action-button"
                onClick={handleSave}
                disabled={disabled || isCurrentSubmitting || !draft.trim()}
              >
                <FormattedMessage id="general.button.save" />
              </Button>
            </div>
          ) : (
            <Button light className="action-button" onClick={handleEdit} disabled={disabled}>
              <FormattedMessage id="general.button.edit" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

ReportSurveyInputSegment.propTypes = {
  checkup: T.object.isRequired,
  paramsCheckupId: T.oneOfType([T.string, T.number]).isRequired,
  isDisabled: T.bool.isRequired,
  isSubmitting: T.bool.isRequired,
  reportSurvey: T.func.isRequired,
  validateCheckup: T.func.isRequired,
  survey: T.object.isRequired,
};

export default connect(
  ({ dailyCheckup }) => ({
    isSubmitting: dailyCheckup.checkupEdit.isReportingSurvey,
    isDisabled: isSomeSectionReporting(dailyCheckup.checkupEdit) && !dailyCheckup.checkupEdit.isReportingSurvey,
  }), {
    reportSurvey,
  }
)(ReportSurveyInputSegment);
